<template>
  <div class="header-container"  v-kiosk>
    <div class="add-tsiyun" @click.stop="addTsiyun"  v-kiosk>
      <span class="plus-tsiyun" v-kiosk>+</span>
    </div>
    <div>{{title}}</div>
  </div>
</template>
<script>
import {mapGetters, mapActions } from "vuex";
import { IPUserNoPersDataMsg } from "@/services/userBooksData.js";
export default {
  props: ["title","tabId"],
  methods: {
    ...mapActions("popupOnceComp", [
      "setVisible",
      "setInvisible",
      "toggleVisible",
      "setSlotShow","setTabId"
    ]),
    addTsiyun() {
            if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      this.setTabId(this.tabId)
      this.setSlotShow("add-tsiyun");
      this.toggleVisible();
    }
  },
  computed:{
    ...mapGetters("user", ["isIPLimited"]),
  }
};
</script>
<style lang="scss" scoped>
.header-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style